// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SharedCasePrescriptionRelationshipModel {
    'prescriptionId'?: number;
    'prescriberId'?: number | null;
    'documentId'?: number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SharedCasePrescriptionRelationshipModel>> = [
        {
            "name":     "prescriptionId",
            "baseName": "prescriptionId",
            "type":     "number"
        },
        {
            "name":     "prescriberId",
            "baseName": "prescriberId",
            "type":     "number"
        },
        {
            "name":     "documentId",
            "baseName": "documentId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return SharedCasePrescriptionRelationshipModel.attributeTypeMap;
    }
}
